module.exports = __webpack_public_path__ + "static/img/Trent-Cotchin.61e314c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Trent-Cotchin.jpg
// module id = C95c
// module chunks = 0